export const GET_RESERVATIONS = 'GET_RESERVATIONS';
export const GET_RESERVATIONBYID = 'GET_RESERVATIONBYID'
export const GET_RESERVATION_SUGGESTED_SEATS = 'GET_RESERVATION_SUGGESTED_SEATS';
